import React from 'react';
import './styles.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', ...props }, ref) => {
    const inputClasses = `input ${className}`.trim();
    
    return (
      <input 
        className={inputClasses}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

